<script setup>
    import { Link } from '@inertiajs/vue3';
    import { useRoute } from 'inertiaRoutes';
    import NavItemDropdown from '@guest/shared/nav/NavItemDropdown.vue';
    import NavDroppedImgSection from '@guest/shared/nav/NavDroppedImgSection.vue';
    import { onMounted } from 'vue';
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { faTimes } from '@fortawesome/pro-regular-svg-icons';
    import { faRightToBracket, faPeopleGroup } from '@fortawesome/pro-duotone-svg-icons';

    library.add(faTimes, faRightToBracket, faPeopleGroup);

    const route = useRoute();
    const id = `navbar-${Math.random()}`;

    import imageUrl from '@/../images/ao/photos/agent-text-at-desk.jpg';

    // The following was pulled from Landkit's 'navbar-dropdown.js' file, which
    // sets up the events to make the menu work as it should for the theme.
    //BEGIN COPY

    // Events
    const showEvents = ['mouseenter', 'focusin'];
    const hideEvents = ['mouseleave', 'click', 'focusout'];

    // Transition
    const transitionDuration = 200;

    // Breakpoint
    const desktopSize = 992;

    //On Mounted added for us so the assignments occur after the components are visible
    onMounted(() => {
        // Selectors
        //Also adjusted to the queried elements only grab those inside our nav
        const drops = document
            .getElementById(id)
            .querySelectorAll('.navbar-nav .dropdown, .navbar-nav .dropend');

        drops.forEach(function (dropdown) {
            const menu = dropdown.querySelector('.dropdown-menu');

            // Show drop
            showEvents.forEach(function (event) {
                dropdown.addEventListener(event, function () {
                    showDrop(menu);
                });
            });

            // Hide drop
            hideEvents.forEach(function (event) {
                dropdown.addEventListener(event, function (e) {
                    hideDrop(e, menu);
                });
            });
        });
    });

    // Show drop
    function showDrop(menu) {
        if (window.innerWidth < desktopSize) {
            return;
        }

        menu.classList.add('showing');

        setTimeout(function () {
            menu.classList.remove('showing');
            menu.classList.add('show');
        }, 1);
    }

    // Hide drop
    function hideDrop(e, menu) {
        setTimeout(function () {
            if (window.innerWidth < desktopSize) {
                return;
            }

            if (!menu.classList.contains('show')) {
                return;
            }

            if (e.type === 'click' && e.target.closest('.dropdown-menu form')) {
                return;
            }

            menu.classList.add('showing');
            menu.classList.remove('show');

            setTimeout(function () {
                menu.classList.remove('showing');
            }, transitionDuration);
        }, 2);
    }
</script>

<template>
    <!-- NAVBAR -->
    <nav :id="id" class="navbar navbar-expand-lg bg-white border-bottom">
        <div class="container-fluid">
            <!-- Brand -->
            <Link class="navbar-brand" :href="route('home')">
                <img
                    src="@/../images/ao/logos/AO_Logo_2020_-_64x64.png"
                    height="48"
                    class="navbar-brand-img"
                    alt="AO Interview Hub" />
            </Link>

            <!-- Toggler -->
            <button
                class="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>

            <!-- Collapse -->
            <div class="collapse navbar-collapse" id="navbarCollapse">
                <!-- Toggler -->
                <button
                    class="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarCollapse"
                    aria-controls="navbarCollapse"
                    aria-expanded="false"
                    aria-label="Toggle navigation">
                    <font-awesome-icon :icon="['far', 'fa-times']" />
                </button>

                <!-- Navigation -->
                <ul class="navbar-nav ms-auto">
                    <nav-item-dropdown
                        id="navDropApply"
                        :title="$t('menus.top.apply.title')"
                        size="xl"
                        :sections="[]">
                        <template v-slot:imageSection>
                            <nav-dropped-img-section :img-url="imageUrl">
                                <h4 class="fw-bold text-white mb-0">
                                    {{ $t('menus.top.apply.dropdown.title') }}
                                </h4>
                                <p class="fs-sm text-white">
                                    {{ $t('menus.top.apply.dropdown.subtitle') }}
                                </p>
                                <Link
                                    :href="route('applicant-apply')"
                                    class="btn btn-sm btn-white shadow-dark fs-6 lift"
                                    role="link"
                                    :aria-label="$t('menus.top.apply.dropdown.button')">
                                    {{ $t('menus.top.apply.dropdown.button') }}
                                </Link>
                            </nav-dropped-img-section>
                        </template>
                    </nav-item-dropdown>
                </ul>

                <ul class="navbar-nav ms-auto me-lg-10">
                    <nav-item-dropdown
                        id="navDropLeadership"
                        :title="$t('menus.top.leaders.title')"
                        size="md"
                        :icons="true"
                        :sections="[
                            {
                                title: $t('menus.top.leaders.login.title'),
                                blurb: $t('menus.top.leaders.login.subtitle'),
                                url: route('login'),
                                icon: ['fad', 'fa-right-to-bracket']
                            },
                            {
                                title: $t('menus.top.leaders.info.title'),
                                blurb: $t('menus.top.leaders.info.subtitle'),
                                url: route('public.info'),
                                icon: ['fad', 'fa-people-group']
                            }
                        ]" />
                </ul>

                <!--                &lt;!&ndash; Button &ndash;&gt;-->
                <!--                <a-->
                <!--                    class="navbar-btn btn btn-sm btn-primary lift ms-auto"-->
                <!--                    href="https://themes.getbootstrap.com/product/landkit/"-->
                <!--                    target="_blank">-->
                <!--                    Buy now-->
                <!--                </a>-->
            </div>
        </div>
    </nav>
</template>

<style scoped></style>
